module.exports = {
	"id": "DJ",
	"name": "Djibouti",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": 0.002627,
			"6": null,
			"7": 0.010508,
			"8": 0.002627,
			"9": 0.010508,
			"10": 0.002627,
			"11": 0.007881,
			"12": 0.005254,
			"13": null,
			"14": 0.007881,
			"15": null,
			"16": 0.005254,
			"17": null,
			"18": 0.002627,
			"19": 0.002627,
			"20": 0.018389,
			"21": 0.021016,
			"22": null,
			"23": null,
			"24": null,
			"25": 0.013135,
			"26": 0.015762,
			"27": 0.010508,
			"28": 0.005254,
			"29": 0.007881,
			"30": 0.055167,
			"31": 0.044659,
			"32": 0.005254,
			"33": 0.023643,
			"34": null,
			"35": 0.002627,
			"36": 0.013135,
			"37": 0.002627,
			"38": 0.013135,
			"39": 0.021016,
			"40": 0.034151,
			"41": 0.018389,
			"42": 0.005254,
			"43": 0.572686,
			"44": 0.275835,
			"45": 0.118215,
			"46": 0.007881,
			"47": 0.036778,
			"48": 0.055167,
			"49": 0.911569,
			"50": 0.126096,
			"51": 0.359899,
			"52": 0.283716,
			"53": 10.933574,
			"54": 3.244345,
			"55": 0.063048,
			"56": 0.021016,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.034151,
			"4": 0.002627,
			"5": null,
			"6": null,
			"7": null,
			"8": 0.005254,
			"9": 0.010508,
			"10": 0.013135,
			"11": 0.005254,
			"12": 0.010508,
			"13": null,
			"14": null,
			"15": 0.010508,
			"16": 0.005254,
			"17": 0.002627,
			"18": 0.002627,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.021016,
			"23": 0.005254,
			"24": 0.015762,
			"25": 0.007881,
			"26": 0.010508,
			"27": null,
			"28": 0.005254,
			"29": 0.007881,
			"30": 0.044659,
			"31": null,
			"32": 0.002627,
			"33": 0.039405,
			"34": 0.028897,
			"35": 0.010508,
			"36": 0.028897,
			"37": null,
			"38": 0.034151,
			"39": 0.031524,
			"40": 0.021016,
			"41": 0.042032,
			"42": 0.021016,
			"43": 0.112961,
			"44": 0.039405,
			"45": 0.031524,
			"46": 0.021016,
			"47": 0.378288,
			"48": 0.302105,
			"49": 2.94224,
			"50": 0.178636,
			"51": 0.007881,
			"52": null,
			"3.5": 0.005254,
			"3.6": 0.010508
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": 0.07881,
			"31": 0.005254,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.005254,
			"37": 0.044659,
			"38": 0.002627,
			"39": 0.015762,
			"40": 0.352018,
			"41": 0.073556,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.002627
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.005254,
			"6": null,
			"7": null,
			"8": 0.005254,
			"9": 0.063048,
			"10": 0.294224,
			"3.1": null,
			"3.2": null,
			"5.1": 0.05254,
			"6.1": 0.018389,
			"7.1": null,
			"9.1": 0.15762
		},
		"ios_saf": {
			"8": 0,
			"10": 1.42617201998,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0384336856786,
			"8.1-8.4": 0.0710046057452,
			"9.0-9.2": 0.0338737568693,
			"9.3": 0.516791931724
		},
		"android": {
			"3": 0,
			"4": 0.166946273902,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0208682842377,
			"4.1": 0.602199059432,
			"4.2-4.3": 1.50549764858,
			"4.4": 3.45221044961,
			"4.4.3-4.4.4": 3.48202228424
		},
		"ie": {
			"6": 0.0132466921769,
			"7": 0.00794801530612,
			"8": 0.169557659864,
			"9": 0.042389414966,
			"10": 0.042389414966,
			"11": 1.28227980272,
			"5.5": null
		},
		"op_mob": {
			"0": 1.0259363085,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0284982307917
		},
		"edge": {
			"12": 0.097199,
			"13": 0.144485,
			"14": 0.278462
		},
		"ie_mob": {
			"10": 0.17007515493,
			"11": 0.69244884507
		},
		"bb": {
			"7": 0.014744,
			"10": null
		},
		"samsung": {
			"0": 2.06416
		},
		"and_uc": {
			"0": 19.727472
		},
		"op_mini": {
			"0": 13.8222614607
		},
		"and_chr": {
			"0": 24.658882
		},
		"and_ff": {
			"0": 0.014744
		}
	},
	"total": 98.701902
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/DJ.json
 ** module id = 507
 ** module chunks = 0
 **/